import { toast } from 'react-toastify';
import axios from 'axios';
import { FORM_ERROR } from 'final-form';
import {
  API_URLS,
  APP_CONTEXT,
  SERVER_ERROR,
  USER_CONTEXT,
} from '../actionTypes';

export const appPropsAction = (payload) => (dispatch) =>
  dispatch({
    type: APP_CONTEXT.SET_APP_PROPS,
    payload,
  });

export const resetAppPropsAction = () => (dispatch) =>
  dispatch({ type: APP_CONTEXT.RESET_APP_PROPS });

//=======================================
// user authentication with email
//=======================================

/**
 *
 * @param {object} data
 */
export const loginAction = (data) => async (dispatch) => {
  dispatch(appPropsAction({ loginLoading: true }));
  try {
    const response = await axios({ ...API_URLS.auth.login, data });
    dispatch({
      type: APP_CONTEXT.LOGIN_SUCCESS,
      payload: { ...response.data, email: data.email },
    });
    dispatch(appPropsAction({ loginLoading: false }));
  } catch (error) {
    dispatch(appPropsAction({ loginLoading: false }));
    dispatch({ type: APP_CONTEXT.LOGIN_FAILURE });
    if (!error.response) {
      toast.error(SERVER_ERROR);
      return;
    }
    const { data } = await error.response;
    if (data && data.errors) {
      return data.errors;
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
    }
  }
};

/**
 *
 * @param {object} data
 */
export const update2FAAction = (data) => async (dispatch) => {
  try {
    const response = await axios({ ...API_URLS.update2fa, data });
    dispatch({
      type: APP_CONTEXT.UPDATE_TWO_FA,
      payload: { ...response.data },
    });
    toast.success('Two-factor authentication has been successfully verified.');
    return response;
  } catch (error) {
    toast.error(error.response?.data.message);
  }
};

/**
 *
 * @param {object} data
 */
export const signupAction = (data) => async (dispatch) => {
  await dispatch(appPropsAction({ signupLoading: true }));
  try {
    const response = await axios({ ...API_URLS.auth.signup, data });
    dispatch({
      type: APP_CONTEXT.SIGNUP_SUCCESS,
      payload: {
        email: data.email,
        token: response.data.token,
        workspaceStep: 'management',
        isAuthenticated: true,
      },
    });
    dispatch(appPropsAction({ signupLoading: false }));
    toast.success(response.data.message);
  } catch (error) {
    dispatch(appPropsAction({ signupLoading: false }));
    dispatch({ type: APP_CONTEXT.SIGNUP_FAILURE });
    if (!error.response) {
      toast.error(SERVER_ERROR);
      return;
    }
    const { data } = await error.response;
    if (data && data.errors) {
      return { ...data.errors };
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
    }
  }
};

/**
 *
 * @param {object} data
 */
export const resendVerificationEmailAction = (data) => async (dispatch) => {
  dispatch(appPropsAction({ resendLoading: true }));
  try {
    const response = await axios({ ...API_URLS.auth.resendEmail, data });
    dispatch({ type: APP_CONTEXT.RESEND_EMAIL_SUCCESS });
    dispatch(appPropsAction({ resendLoading: false }));
    toast.success(response.data.message);
  } catch (error) {
    dispatch(appPropsAction({ resendLoading: false }));
    const { data } = await error.response;
    if (data && data.errors) {
      toast.error(data.errors.email);
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
    }
  }
};

/**
 *
 * @param {string} token
 */
export const emailConfirmationAction = (token) => async (dispatch) => {
  dispatch(appPropsAction({ emailConfirmLoading: true }));
  try {
    const response = await axios({
      ...API_URLS.auth.emailConfirmation,
      url: `${API_URLS.auth.emailConfirmation.url}/${token}`,
    });
    dispatch({ type: APP_CONTEXT.CONFIRM_EMAIL_SUCCESS });
    dispatch(appPropsAction({ emailConfirmLoading: false }));
    toast.success(response.data.message);
  } catch (error) {
    dispatch(appPropsAction({ emailConfirmLoading: false }));
    const { data } = await error.response;
    const message = data && data.message ? data.message : error.message;
    toast.error(message);
  }
};

/**
 *
 * @param {object} data
 */
export const forgotPasswordAction = (data) => async (dispatch) => {
  dispatch(appPropsAction({ forgotPasswordLoading: true }));
  try {
    const response = await axios({
      ...API_URLS.auth.forgotPassword,
      data,
    });
    dispatch({ type: APP_CONTEXT.FORGOT_PASSWORD_SUCCESS });
    dispatch(appPropsAction({ forgotPasswordLoading: false }));
    toast.success(response.data.message);
  } catch (error) {
    dispatch(appPropsAction({ forgotPasswordLoading: false }));
    if (!error.response) {
      toast.error(SERVER_ERROR);
      return;
    }
    const { data } = await error.response;
    if (data && data.errors) {
      return { ...data.errors };
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

/**
 *
 * @param {string} token
 */
export const resetPasswordVerificationAction = (token) => async (dispatch) => {
  dispatch(appPropsAction({ resetPasswordVerifyLoading: true }));
  try {
    await axios({
      ...API_URLS.auth.resetPasswordToken,
      url: `${API_URLS.auth.resetPasswordToken.url}/${token}`,
    });
    dispatch({ type: APP_CONTEXT.RESET_PASSWORD_VERIFY_SUCCESS });
    dispatch(appPropsAction({ resetPasswordVerifyLoading: false }));
  } catch (error) {
    dispatch(appPropsAction({ resetPasswordVerifyLoading: false }));
    const { data } = await error.response;
    const message = data && data.message ? data.message : error.message;
    toast.error(message);
  }
};

/**
 *
 * @param {object} data
 * @param {string} token
 */
export const resetPasswordAction = (data, token) => async (dispatch) => {
  dispatch(appPropsAction({ resetPasswordLoading: true }));
  try {
    const response = await axios({
      ...API_URLS.auth.resetPassword,
      url: `${API_URLS.auth.resetPassword.url}/${token}`,
      data,
    });
    dispatch({ type: APP_CONTEXT.RESET_PASSWORD_SUCCESS });
    dispatch(appPropsAction({ resetPasswordLoading: false }));
    toast.success(response.data.message);
  } catch (error) {
    dispatch(appPropsAction({ resetPasswordLoading: false }));
    const { data } = await error.response;
    if (data && data.errors) {
      return { ...data.errors };
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

//=======================================
// invitation actions & authentiation
//=======================================

/**
 *
 * @param {string} token
 * @param {boolean} isLoggedIn [default: false]
 */
export const invitationAuthAction =
  (token, isLoggedIn = false) =>
  async (dispatch) => {
    dispatch(appPropsAction({ authInvitationLoading: true }));
    try {
      const response = await axios({
        ...API_URLS.invitation.verification,
        url: `${API_URLS.invitation.verification.url}/${token}`,
      });
      dispatch({
        type: APP_CONTEXT.AUTH_INVITATION_SUCCESS,
        payload: { token, ...response.data },
      });
      if (isLoggedIn)
        dispatch({
          type: USER_CONTEXT.ACCEPT_WS_INVITATION_SUCCESS,
          payload: { token, ...response.data },
        });
      dispatch(appPropsAction({ authInvitationLoading: false }));
      if (response.data && response.data.isInvitationAccepted)
        toast.success(
          'Your account has successfully added to the invited workspace'
        );
    } catch (error) {
      dispatch(appPropsAction({ authInvitationLoading: false }));
      dispatch({ type: APP_CONTEXT.AUTH_INVITATION_FAILURE });
      if (!error.response) {
        toast.error(SERVER_ERROR);
        return;
      }
      const { data } = await error.response;
      if (data && data.errors) {
        return data.errors;
      } else {
        const message = data && data.message ? data.message : error.message;
        toast.error(message);
      }
    }
  };

/**
 *
 * @param {object} data
 * @param {string} token
 */
export const invitationAcceptAction = (data, token) => async (dispatch) => {
  dispatch(appPropsAction({ acceptInvitationLoading: true }));
  try {
    const response = await axios({
      ...API_URLS.invitation.add,
      url: `${API_URLS.invitation.add.url}/${token}`,
      data,
    });
    dispatch({ type: APP_CONTEXT.ADD_INVITATION_SUCCESS, payload: token });
    dispatch(appPropsAction({ acceptInvitationLoading: false }));
    toast.success(response.data.message);
  } catch (error) {
    dispatch(
      appPropsAction({
        acceptInvitationLoading: false,
        invitationAccepted: null,
      })
    );
    const { data } = await error.response;
    if (data && data.errors) {
      return { ...data.errors };
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

/**
 *
 * @param {string} reference
 */
export const workspaceByReferenceAction = (reference) => async (dispatch) => {
  dispatch(appPropsAction({ wsReferenceLoading: true }));
  try {
    const response = await axios({
      ...API_URLS.workspace.byReference,
      url: `${API_URLS.workspace.byReference.url}/${reference}`,
    });
    dispatch({
      type: APP_CONTEXT.GET_WSREFERNCE_SUCCESS,
      payload: response.data,
    });
    dispatch(appPropsAction({ wsReferenceLoading: false }));
  } catch (error) {
    dispatch(appPropsAction({ wsReferenceLoading: false }));
    const { data } = await error.response;
    const message = data && data.message ? data.message : error.message;
    toast.error(message);
  }
};
